import { render, staticRenderFns } from "./by_zy.vue?vue&type=template&id=2fdf6f9e&scoped=true"
import script from "./by_zy.vue?vue&type=script&lang=js"
export * from "./by_zy.vue?vue&type=script&lang=js"
import style0 from "./by_zy.vue?vue&type=style&index=0&id=2fdf6f9e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdf6f9e",
  null
  
)

export default component.exports